// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-page-details-___page-details__header___JHSOX {
  display: flex;
  margin: 0 -15px;
}

.src-components-page-details-___page-details__header-section-title___uChkx, .src-components-page-details-___page-details__header-section-pager___p6Uyg {
  padding: var(--container-padding);
}

.src-components-page-details-___page-details__header-section-title___uChkx {
  flex: 1 0 75%;
}

.src-components-page-details-___page-details__header-section-pager___p6Uyg {
  flex: 1 0 25%;
}

.src-components-page-details-___page-details__page-details-main___ufOR0 {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  padding: 15px;
}

.src-components-page-details-___page-details__page-title___Ybn02 {
  font-size: 1.5em;
  margin-bottom: 0;
  margin-top: 0.3em;
  margin-right: 0.75em;
  display: inline;
}

.src-components-page-details-___page-details__info-items___AGxrX {
  display: inline;
  margin: 0.1em 0 0.25em;
}

.src-components-page-details-___page-details__info-item___qw0pp {
  margin-right: 1em;
  white-space: nowrap;
}

.src-components-page-details-___page-details__info-item___qw0pp[data-page-active="false"] {
  color: var(--gray-light)
}

.src-components-page-details-___page-details__status-error___ew_uJ {
  color: var(--danger-text);
  font-weight: bold;
}

.src-components-page-details-___page-details__status-ok___vwSnM {
  color: inherit;
}

.src-components-page-details-___page-details__page-url___zjLYH {
  display: block;
}

.src-components-page-details-___page-details__pager___ewZkM {
  display: flex;
  margin: 0;
  padding-left: 0;
  list-style: none;
  text-align: center;
}

.src-components-page-details-___page-details__pager___ewZkM li > a,
.src-components-page-details-___page-details__pager___ewZkM li > span {
  display: inline-block;
  padding: 5px 14px;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 3px;
  flex: 1 0 auto;
}

.src-components-page-details-___page-details__pager___ewZkM li {
  display: flex;
  flex: 1 0 50%;
}

.src-components-page-details-___page-details__pager___ewZkM li > a:focus {
  text-decoration: none;
  background-color: #f7f7f7;
}

.src-components-page-details-___page-details__pager___ewZkM li > a:hover {
  text-decoration: none;
  background-color: rgba(139, 227, 255, 0.46);
}

.src-components-page-details-___page-details__pager-prev___yqdwJ {
  margin-right: 5px;
}

.src-components-page-details-___page-details__pager-prev___yqdwJ .src-components-page-details-___page-details__fa___LGCzJ {
  margin-right: 0;
}

@media (max-width: 992px) {
  .src-components-page-details-___page-details__header___JHSOX {
    flex-direction: column;
  }

  .src-components-page-details-___page-details__header-section-title___uChkx, .src-components-page-details-___page-details__header-section-pager___p6Uyg {
    flex: 1 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/page-details/page-details.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".header {\n  display: flex;\n  margin: 0 -15px;\n}\n\n.header-section-title, .header-section-pager {\n  padding: var(--container-padding);\n}\n\n.header-section-title {\n  flex: 1 0 75%;\n}\n\n.header-section-pager {\n  flex: 1 0 25%;\n}\n\n.page-details-main {\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n  padding: 15px;\n}\n\n.page-title {\n  font-size: 1.5em;\n  margin-bottom: 0;\n  margin-top: 0.3em;\n  margin-right: 0.75em;\n  display: inline;\n}\n\n.info-items {\n  display: inline;\n  margin: 0.1em 0 0.25em;\n}\n\n.info-item {\n  margin-right: 1em;\n  white-space: nowrap;\n}\n\n.info-item[data-page-active=\"false\"] {\n  color: var(--gray-light)\n}\n\n.status-error {\n  color: var(--danger-text);\n  font-weight: bold;\n}\n\n.status-ok {\n  color: inherit;\n}\n\n.page-url {\n  display: block;\n}\n\n.pager {\n  display: flex;\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n  text-align: center;\n}\n\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #f7f7f7;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  flex: 1 0 auto;\n}\n\n.pager li {\n  display: flex;\n  flex: 1 0 50%;\n}\n\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #f7f7f7;\n}\n\n.pager li > a:hover {\n  text-decoration: none;\n  background-color: rgba(139, 227, 255, 0.46);\n}\n\n.pager-prev {\n  margin-right: 5px;\n}\n\n.pager-prev .fa {\n  margin-right: 0;\n}\n\n@media (max-width: 992px) {\n  .header {\n    flex-direction: column;\n  }\n\n  .header-section-title, .header-section-pager {\n    flex: 1 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `src-components-page-details-___page-details__header___JHSOX`,
	"header-section-title": `src-components-page-details-___page-details__header-section-title___uChkx`,
	"headerSectionTitle": `src-components-page-details-___page-details__header-section-title___uChkx`,
	"header-section-pager": `src-components-page-details-___page-details__header-section-pager___p6Uyg`,
	"headerSectionPager": `src-components-page-details-___page-details__header-section-pager___p6Uyg`,
	"page-details-main": `src-components-page-details-___page-details__page-details-main___ufOR0`,
	"pageDetailsMain": `src-components-page-details-___page-details__page-details-main___ufOR0`,
	"page-title": `src-components-page-details-___page-details__page-title___Ybn02`,
	"pageTitle": `src-components-page-details-___page-details__page-title___Ybn02`,
	"info-items": `src-components-page-details-___page-details__info-items___AGxrX`,
	"infoItems": `src-components-page-details-___page-details__info-items___AGxrX`,
	"info-item": `src-components-page-details-___page-details__info-item___qw0pp`,
	"infoItem": `src-components-page-details-___page-details__info-item___qw0pp`,
	"status-error": `src-components-page-details-___page-details__status-error___ew_uJ`,
	"statusError": `src-components-page-details-___page-details__status-error___ew_uJ`,
	"status-ok": `src-components-page-details-___page-details__status-ok___vwSnM`,
	"statusOk": `src-components-page-details-___page-details__status-ok___vwSnM`,
	"page-url": `src-components-page-details-___page-details__page-url___zjLYH`,
	"pageUrl": `src-components-page-details-___page-details__page-url___zjLYH`,
	"pager": `src-components-page-details-___page-details__pager___ewZkM`,
	"pager-prev": `src-components-page-details-___page-details__pager-prev___yqdwJ`,
	"pagerPrev": `src-components-page-details-___page-details__pager-prev___yqdwJ`,
	"fa": `src-components-page-details-___page-details__fa___LGCzJ`
};
export default ___CSS_LOADER_EXPORT___;
